import { css, LitElement, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { live } from "lit/directives/live.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var OfferRadioButtonType = /* @__PURE__ */ ((OfferRadioButtonType2) => {
  OfferRadioButtonType2[OfferRadioButtonType2["ACCEPTED"] = 0] = "ACCEPTED";
  OfferRadioButtonType2[OfferRadioButtonType2["DECLINED"] = 1] = "DECLINED";
  return OfferRadioButtonType2;
})(OfferRadioButtonType || {});
let OfferRadioButton = class extends LitElement {
  constructor() {
    super(...arguments);
    this.checked = false;
  }
  change(e) {
    this.dispatchEvent(new Event(e.type, e));
  }
  render() {
    return html`
      <label class=${classMap({ "type-accept": this.type === 0, "type-decline": this.type === 1, "display-checkbox": this.display === "checkbox" })}>
        <input type="radio" .checked=${live(this.checked)} @change=${this.change}>
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 16 16" fill="currentColor"><circle data-name="ellipse" cx="8" cy="8" r="8"></circle></svg>
        </span> 
        <slot></slot>
      </label>
  `;
  }
};
OfferRadioButton.styles = css`

    input[type=radio] {
      scale: var(--default-vi-action-radio-scale);
      height: 16px;
      aspect-ratio: 1;
      border-width: 1px;
      border-style: solid;
      border-radius: 50%;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      cursor: pointer;
      font-size: inherit;
      transition: .3s;
      margin: 0;
      background-color: #ffffff;
    }

    label span {
      scale: var(--default-vi-action-radio-scale);
      position: relative;
      width: 0px;
      height: 0px;
      line-height: 0px;
      opacity: 1;
      width: 10px;
      height: 10px;
      left: -13px;
      transform: scale(0);
    }

    input[type=radio]:checked + span {
      transform: scale(1);
      transition: 120ms transform ease-in-out;
    }
    
    @media print {
      input[type=radio] {
        -webkit-appearance: auto;
        -moz-appearance: auto;
        appearance: auto;
        background: none;
      }
    }
    
    label {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: var(--default-vi-action-padding);
      position: relative;
      border-radius: var(--default-vi-action-border-radius);
      font-family: var(--default-vi-font-family);
      font-size: var(--default-vi-font-md);
    }

    .type-accept input[type=radio] {
      border-color: var(--default-vi-action-accept-border-color);
    }

    label.type-accept  {
      color: var(--default-vi-accept-text-color);
      font-weight: var(--default-vi-action-accept-font-weight);
      border: 1px solid var(--default-vi-action-accept-border-color);
      background-color: var(--default-vi-action-accept-bg-color);
    }

    .type-accept input[type=radio]:checked + span {
      color: var(--default-vi-action-accept-radio-color);
    }

    .type-decline input[type=radio] {
      border-color: var(--default-vi-action-decline-border-color);
    }

    .type-decline input[type=radio]:checked + span {
      color: var(--default-vi-action-decline-radio-color);
    }

    label.type-decline  {
      color: var(--default-vi-action-decline-text-color);
      border: 1px solid var(--default-vi-action-decline-border-color);
      background-color: var(--default-vi-action-decline-bg-color);
    }

    label.display-checkbox {
      padding: var(--default-vi-action-checklist-item-padding);
    }

    label.display-checkbox input[type=radio] {
      scale: var(--default-vi-action-checkbox-scale);
      border-radius: 5px;
      width: 1.25rem;
      height: 1.25rem;
      position: relative;
      margin: 0 8px 0 0;
    }

    label.display-checkbox input[type=radio]:checked {
      background-color: var(--default-vi-action-decline-radio-color);
      border-color: var(--default-vi-action-decline-radio-color);
    }

    label.display-checkbox input[type=radio]:checked + span, 
    label.display-checkbox input[type=radio] + span {
      display: none;
    }

    label.display-checkbox input[type=radio]:checked::before {
      content:'';
      position: absolute;
      top: 50%; 
      right: 0;
      left: 50%;
      bottom: 0;
      transform:translate(-50%,-50%) rotate(45deg);
      background-color:#ffffff;
      width: calc(14px * var(--default-vi-action-checkbox-scale));
      height: calc(2px * var(--default-vi-action-checkbox-scale));
      transition:all .5s;
    }

    label.display-checkbox input[type=radio]:checked::after {
      content:'';
      position: absolute;
      top: 50%;
      left: 50%;
      transform:translate(-50%,-50%) rotate(-45deg);
      background-color:#ffffff;
      width: calc(14px * var(--default-vi-action-checkbox-scale));
      height: calc(2px * var(--default-vi-action-checkbox-scale));
      transition:all .5s;
    }
  `;
__decorateClass([
  property({ type: Number })
], OfferRadioButton.prototype, "type", 2);
__decorateClass([
  property({ type: Boolean })
], OfferRadioButton.prototype, "checked", 2);
__decorateClass([
  property({ type: String })
], OfferRadioButton.prototype, "display", 2);
OfferRadioButton = __decorateClass([
  customElement("offer-radio-button")
], OfferRadioButton);
export {
  OfferRadioButton,
  OfferRadioButtonType
};
